export const positionOptions = [
  'careHomeManager',
  'careLead',
  'qualityManager',
  'headOfCareUnit',
  'registeredNurse',
];